<template>
  <div>
    <div class="opinion-scale-wrapper">
      <div class="opinion-scale">
        <div
          v-for="(n, index) in scaleStep"
          :key="index"
          class="opinion-scale-step"
          v-on:click="select($event, n)"
        >
          {{ n }}
        </div>
      </div>
    </div>
    <div class="opinion-scale-label">
      <span>
        {{ question.label.left }}
      </span>
      <span>
        {{ question.label.right }}
      </span>
    </div>
  </div>
</template>

<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: BaseType,
  name: QuestionType.Scale,
  computed: {
    scaleStep() {
      let step;
      if(!this.question.scaleStep) {
        step = 10
      } else {
        step = this.question.scaleStep
      }
      return step;
    }
  },
  methods: {
    onEnter() {
      this.dirty = true;

      this._onEnter();
    },

    isValid() {
      return true;
    },

    select(event, value) {
      this.onChange(value);
      const items = document.querySelectorAll(".opinion-scale-step");
      for (var i = 0; i < items.length; i++) {
        // Remove the .active class
        items[i].classList.remove("active");
      }
      const el = event.target;
      el.classList.add("active");
    },
    onChange(value) {
      this.dirty = true;
      this.dataValue = value;

      this.onKeyDown();
      this.setAnswer(this.dataValue);
    }
  }
};
</script>

<style scoped>
.opinion-scale {
  display: flex;
  flex-direction: row;
}

.opinion-scale-step {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-grow: 1;
  height: 53px;
  margin-right: 8px;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
}

@media screen and (max-width: 580px) {
  .opinion-scale-step {
    height: 32px !important;
    font-size: 10px;
    padding: 4px 8px;
    margin-right: 4px;
  }
}

@media screen and (max-width: 320px) {
  .opinion-scale-step {
    width: 25px;
    height: 25px;
    font-size: 10px;
  }
}

.opinion-scale-step:last-child {
  margin-right: 0 !important;
}
</style>
